import React, {useContext, useEffect, useState} from 'react'
import {InputErrorType, RoleContextValue, SubmitAPIStatusType} from '../../types/OtherTypes'
import {APIStatusData, SubmitAPIStatusData} from '../../data/OtherDefaultData'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import {changeTextCamal, checkRole} from '../../../_metronic/helpers'
import ActionColumn from '../../components/ActionColumn'
import {
  cancelSubmit,
  deleteRecord,
  getRecords,
  handleInputChange,
  handleSubmit,
} from '../../CommonFunction'
import {
  getLeaveTypeByID,
  getLeaveTypeTableHeaderData,
  validateForm,
} from './LeaveTypesHelperFunction'
import CustomTable from '../../components/CustomTable'
import {Button} from '@mantine/core'
import {Modal} from 'react-bootstrap'
import API from '../../../api/APIUrl'
import CustomTextInput from '../../components/CustomInput/CustomTextInput'
import CustomNumberInput from '../../components/CustomInput/CustomNumberInput'
import SubmitCancleButton from '../../components/SubmitCancelButton'
import {EmploymentTypeInitialInput} from '../../data/AdminModuleDefaultData'
import roleContext from '../../context/roleContext'
import {addLeaveTypes, updateLeaveTypesById} from '../../../api/ConfigurationAPI'
import {LeaveTypeInput, LeaveTypeOutput} from '../../types/SettingModuleTypes'

const LeaveTypes = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  const [editId, setEditId] = useState<string | null>(null)
  const [submitAPIStatus, setSubmitAPIStatus] = useState<SubmitAPIStatusType>(SubmitAPIStatusData)
  const [showForm, setShowForm] = useState<boolean>(false)
  const [inputError, setInputError] = useState<InputErrorType>({})
  const {leaveTypeTableHeaderData} = getLeaveTypeTableHeaderData(
    !checkRole(['leave_types_edit'], roleState.features)
  )
  const [leaveType, setLeaveType] = useState<LeaveTypeOutput>({...APIStatusData, data: []})
  const [formField, setFormField] = useState<LeaveTypeInput>(EmploymentTypeInitialInput)
  const getTableBody = () => {
    return leaveType?.data.map((obj) => {
      return (
        <tr key={obj?.id} className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}>
          <td>{changeTextCamal(obj?.name ?? '-')}</td>
          <td>{obj?.description}</td>
          <td hidden={!checkRole(['leave_types_edit'], roleState.features)}>
            <ActionColumn
              edit={{
                onClick: () => {
                  getLeaveTypeByID(
                    obj.id,
                    formField,
                    setFormField,
                    setEditId,
                    setShowForm,
                    setInputError
                  )
                },
              }}
              remove={{
                onClick: () =>
                  deleteRecord(
                    `${API.LEAVETYPE}/${obj.id}`,
                    setLeaveType,
                    setFormField,
                    setEditId,
                    setInputError,
                    EmploymentTypeInitialInput,
                    setShowForm,
                    `${API.LEAVETYPE}`
                  ),
              }}
            />
          </td>
        </tr>
      )
    })
  }
  useEffect(() => {
    let mounted = true
    if (mounted) {
      getRecords(`${API.LEAVETYPE}`, setLeaveType)
    }
    return () => {
      mounted = false
    }
  }, [])
  return (
    <div className='row justify-content-center'>
      <div className='col-md-6 col-12'>
        <CustomTable
          data={leaveType}
          setData={setLeaveType}
          url={`${API.LEAVETYPE}`}
          tableBody={getTableBody}
          tableHeadData={leaveTypeTableHeaderData}
          tableLabel='Leave Types'
          isSortingRequired={false}
          newRecordButton={
            <Button
              type='button'
              className='btn btn-primary btn-sm me-3'
              onClick={() => setShowForm(true)}
              hidden={showForm || !checkRole(['leave_types_edit'], roleState.features)}
            >
              Add Leave Types
            </Button>
          }
        />
        <Modal show={showForm} animation={false} backdrop='static' centered>
          <div className='modal-header'>
            <h2 className='fw-bolder'>{editId !== null ? 'Update' : 'Add'} Leave Types</h2>
            <div
              className='btn btn-icon btn-sm btn-active-icon-danger'
              data-kt-users-modal-action='close'
              style={{cursor: 'pointer'}}
              onClick={() => {
                cancelSubmit(
                  setFormField,
                  setEditId,
                  setInputError,
                  EmploymentTypeInitialInput,
                  setShowForm
                )
              }}
            >
              <i className='fa-solid fa-xmark fs-1' />
            </div>
          </div>
          <div className='m-3'>
            <div className='row ms-3'>
              <div className='fv-row me-6 col-md-5 col-6 mb-3'>
                <CustomTextInput
                  name='name'
                  value={formField.name}
                  onChange={(event) =>
                    handleInputChange(event, setFormField, inputError, setInputError)
                  }
                  label='Leave Type Type'
                  id='name'
                  error={inputError.name}
                />
              </div>

              <div className='fv-row me-6 col-md-5 col-6 mb-3'>
                <CustomTextInput
                  name='description'
                  value={formField.description}
                  onChange={(event) =>
                    handleInputChange(event, setFormField, inputError, setInputError)
                  }
                  label='Description'
                  id='description'
                  error={inputError.description}
                />
              </div>
            </div>
            <SubmitCancleButton
              cancle={{
                onClick: () => {
                  cancelSubmit(
                    setFormField,
                    setEditId,
                    setInputError,
                    EmploymentTypeInitialInput,
                    setShowForm
                  )
                },
              }}
              submit={{
                editid: editId,
                loading: submitAPIStatus.loading,
                onClick: () =>
                  handleSubmit(
                    `${API.LEAVETYPE}`,
                    formField,
                    EmploymentTypeInitialInput,
                    setLeaveType,
                    setEditId,
                    setFormField,
                    editId,
                    setInputError,
                    validateForm,
                    setSubmitAPIStatus,
                    addLeaveTypes,
                    updateLeaveTypesById,
                    setShowForm
                  ),
              }}
            />
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default LeaveTypes
